import { CUSTOMER_APIS } from "@/api_framework/api_config";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

AxiosCurlirize(axios, () => {});
export type AddAddressAPIOptions = {
  refetchCustomerDetails?: boolean;
};

type InventoryTaxCreateAPIResponse = { status: boolean; message: string };
export interface IPerSonaProps {
  persona_tags: Array<string>;
}
// returns new created addressID
export const useUserPerSonaAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (filterParams: IPerSonaProps, user_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .put(`${CUSTOMER_APIS?.PERSONA_CREATION_API?.baseURL}${user_id}` ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              toast.success("Persona has been created.");
              return { status: true, message: res.data.data.membership_id };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
